<template>
  <div>
    <data-table
      ref="tabelaClientes"
      api-route="/clientes/"
      item-key="codcliente"
      :columns="columns"
      :filters="filters"
      :actions="actions"
      sort-by="codcliente"
      :sort-desc="true"
    />
    <FloatBtn text="Cadastrar Cliente" :to="{ name: 'cadastro-cliente' }" />
    <router-view />

    <CadastroEmpresaClienteDialog 
      v-model="dialogCadastroEmpresa" 
      :codcliente="selectedCodCliente" 
      @empresa-cadastrada="onEmpresaCadastrada" 
    />

    <ListarEmpresasClienteDialog
      v-model="dialogListarEmpresas"
      :codcliente="selectedCodClienteListar"
    />
  </div>
</template>

<script>
import DataTable from './comum/DataTable.vue';
import FloatBtn from './FloatBtn.vue';
import CadastroEmpresaClienteDialog from './CadastroEmpresaClienteDialog.vue';
import ListarEmpresasClienteDialog from './ListarEmpresasClienteDialog.vue';

export default {
  components: {
    DataTable,
    FloatBtn,
    CadastroEmpresaClienteDialog,
    ListarEmpresasClienteDialog
  },
  data() {
    return {
      dialogCadastroEmpresa: false,
      selectedCodCliente: null,
      dialogListarEmpresas: false,
      selectedCodClienteListar: null,
      columns: [
        { key: 'codcliente', title: 'CodCliente' },
        { key: 'razao_social', title: 'Razão Social' },
        { key: 'cnpj_cpf', title: 'CNPJ/CPF' },
      ],
      filters: [
        { model: 'razao_social', label: 'Filtrar por Razão Social', icon: 'mdi-magnify' },
        { model: 'cnpj_cpf', label: 'Filtrar por CNPJ/CPF', icon: 'mdi-card-account-details' },
        { model: 'codcliente', label: 'Filtrar por Código', type: 'number', icon: 'mdi-numeric' },
      ],
      actions: [
        { 
          icon: 'mdi-pencil', 
          tooltip: 'Editar',
          color: 'primary',
          handler: (item) => {
            this.$router.push({ name: 'editar-cliente', params: { codcliente: item.codcliente } });
          }
        },
        { 
          icon: 'mdi-certificate', 
          tooltip: 'Ver Licença',
          color: 'info',
          handler: (item) => {
            this.$router.push({ name: 'licenca-detalhe', params: { hash: item.codcliente } });
          }
        },
        { 
          icon: 'mdi-domain-plus', 
          tooltip: 'Criar Empresa Cliente',
          color: 'success',
          handler: (item) => this.abrirDialogEmpresa(item)
        },
        { 
          icon: 'mdi-domain', 
          tooltip: 'Listar Empresas do Cliente',
          color: 'purple',
          handler: (item) => this.abrirDialogListarEmpresas(item)
        }
      ]
    };
  },
  methods: {
    abrirDialogEmpresa(cliente) {
      this.selectedCodCliente = cliente.codcliente;
      this.dialogCadastroEmpresa = true;
    },
    onEmpresaCadastrada() {
      this.dialogCadastroEmpresa = false;
      this.$refs.tabelaClientes.recarregar();
    },
    abrirDialogListarEmpresas(cliente) {
      this.selectedCodClienteListar = cliente.codcliente;
      this.dialogListarEmpresas = true;
    }
  },
};
</script>